//@ts-nocheck
import {
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  useColorModeValue as mode,
} from "@chakra-ui/react";
import { Field } from "formik";
import React from "react";
import {
  FormContainer,
  useFFormContext,
} from "../../../../primitives/forms/FormField";
import { useGoogleAutocomplete } from "./Map";
// import "./Autocomplete.css";

export const AutocompleFormField: React.FC<{
  name: string;
  label?: string;
  placeholder?: string;
  hideLabel?: boolean;
  onBlur: any;
  isInline?: boolean;
  helpText?: string;
  onChange?: any;
  errorMessage?: string;
  field: any;
  inputProps?: any;
  isInvalid?: boolean;
  countryCode?: string;
}> = ({
  isInvalid,
  isInline,
  hideLabel,
  name,
  helpText,
  label,
  onChange,
  placeholder,
  inputProps = {},
  field,
  onBlur,
  errorMessage,
  countryCode,
  ...rest
}) => {
  const labelColor = mode("gray.700", "gray.200");

  const { inputNode } = useGoogleAutocomplete({
    onClick: onChange,
    countryCode,
    defaultValue: field.value,
  });

  return (
    <FormControl flex={1} isInvalid={isInvalid} id={name} {...rest}>
      <FormContainer isInline={isInline}>
        {hideLabel ? null : (
          <FormLabel color={labelColor} htmlFor={name}>
            {label}
          </FormLabel>
        )}
        {helpText ? <FormHelperText mb={2}>{helpText}</FormHelperText> : null}
        <Input
          name={name}
          placeholder={placeholder}
          type={"text"}
          {...inputProps}
          {...field}
          ref={inputNode}
          minH="3rem"
          sx={{
            ".pac-item-query": {
              color: "red",
              height: "16px",
              fontSize: "78px",
            },
          }}
          onBlur={onBlur}
        />
      </FormContainer>
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
};

export const AutocompleteFFormField: React.FC<{
  name: string;
  label?: string;
  placeholder?: string;
  hideLabel?: boolean;
  onBlur?: any;
  isInline?: boolean;
  helpText?: string;
  onChange?: any;
  countryCode?: string;
}> = ({
  name,
  label,
  placeholder,
  hideLabel,
  isInline,
  onBlur,
  onChange,
  helpText,
  countryCode = "ng",
}) => {
  let { commonProps, inputProps, formControlProps } = useFFormContext({
    placeholder,
    label,
  });

  // const { inputNode } = useGoogleAutocomplete({
  //   onClick: onChange,
  //   countryCode,
  // });

  return (
    <Field name={name}>
      {({ field, form }) => {
        return (
          <AutocompleFormField
            isInvalid={commonProps(field, form).isInvalid}
            name={name}
            isInline={isInline}
            hideLabel={hideLabel}
            label={label || commonProps(field, form).label}
            helpText={helpText}
            placeholder={placeholder || commonProps(field, form).placeholder}
            inputProps={inputProps}
            field={field}
            onBlur={
              onBlur
                ? (e) => {
                    onBlur(e, form);
                  }
                : field?.onBlur
            }
            errorMessage={commonProps(field, form).errorMessage}
            onChange={onChange}
            countryCode={countryCode}
            {...formControlProps}
          />
        );
        // return (
        //   <FormControl
        //     flex={1}
        //     isInvalid={commonProps(field, form).isInvalid}
        //     id={name}
        //     {...formControlProps}
        //   >
        //     <FormContainer isInline={isInline}>
        //       {hideLabel ? null : (
        //         <FormLabel color={labelColor} htmlFor={name}>
        //           {label || commonProps(field, form).label}
        //         </FormLabel>
        //       )}
        //       {helpText ? (
        //         <FormHelperText mb={2}>{helpText}</FormHelperText>
        //       ) : null}
        //       <Input
        //         name={name}
        //         placeholder={
        //           placeholder || commonProps(field, form).placeholder
        //         }
        //         type={"text"}
        //         {...inputProps}
        //         {...field}
        //         ref={inputNode}
        //         sx={{
        //           ".pac-item-query": {
        //             color: "red",
        //             height: "16px",
        //             fontSize: "78px",
        //           },
        //         }}
        //         onBlur={
        //           onBlur
        //             ? (e) => {
        //                 onBlur(e, form);
        //               }
        //             : field?.onBlur
        //         }
        //       />
        //     </FormContainer>
        //     <FormErrorMessage>
        //       {commonProps(field, form).errorMessage}
        //     </FormErrorMessage>
        //   </FormControl>
        // );
      }}
    </Field>
  );
};
